import { render, staticRenderFns } from "./ChangesSaved.vue?vue&type=template&id=5f318bde&"
import script from "./ChangesSaved.vue?vue&type=script&lang=js&"
export * from "./ChangesSaved.vue?vue&type=script&lang=js&"
import style0 from "./ChangesSaved.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports